import React from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

import { strings, getCurrentLocale } from '../../../../../localization';

import VehicleInfo from './VehicleInfo';
import VehicleTags from './VehicleTags';
import Protected from '../../../../common/protected';
import EventSection from '../../eventSection';
import LiveMedia from 'APP_ROOT/components/pages/dashboard/LiveMedia/LiveMedia'; /* index.js for redux is not available yet */
import EventMedia from 'APP_ROOT/components/pages/dashboard/EventMedia';
import EventClusterMediaCarousel from 'APP_ROOT/components/pages/dashboard/EventMedia/EventClusterMediaCarousel'
import { EVENT_MEDIA_REQUEST_TYPE } from  'APP_ROOT/components/pages/dashboard/EventMedia/eventMediaConstants';
import RavenUtil from '../../../../common/ravenUtil';

import {RESOURCE_DETAILS_VEHICLE_INFO_UNIQUE_ID,
        RESOURCE_DETAILS_EVENT_SECTION_UNIQUE_ID,
        printResourceDetailsForTrip} from '../../../../common/printUtil';

export default class VehicleDetail extends React.PureComponent {

    constructor(props) { 
        super(props);

        this.state = {
        };

        //keeping this as a reminder that printing via react refs is overly-complicated (innerHTML is inaccessible, findDOMNode is deprecated, etc etc)
        //this.vehicleInfoPrintRef = React.createRef();
        //this.eventSectionPrintRef = React.createRef();
    }


    componentDidMount() {
    }

    static getDerivedStateFromProps(props, state) {

        if (!props.selectedRaven) { // RAV-3903
            return;
        }

        var liveMediaRoadCameraImage;
        var liveMediaRoadCameraDate;
        var liveMediaCabinCameraImage;
        var liveMediaCabinCameraDate;

        if (props.selectedRaven.liveMedia) {
            if (props.selectedRaven.liveMedia.length > 0) {
                if (props.selectedRaven.liveMedia[0] && props.selectedRaven.liveMedia[0].base64Image) { // RAV-3903 (added truthy check for liveMedia's element at index 0)
                    liveMediaRoadCameraImage = props.selectedRaven.liveMedia[0].base64Image;
                    liveMediaRoadCameraDate = props.selectedRaven.liveMedia[0].timestamp;
                }
                if (props.selectedRaven.liveMedia.length > 1) {
                    if (props.selectedRaven.liveMedia[1] && props.selectedRaven.liveMedia[1].base64Image) { // RAV-3903 (added truthy check for liveMedia's element at index 1)
                        liveMediaCabinCameraImage = props.selectedRaven.liveMedia[1].base64Image;
                        liveMediaCabinCameraDate = props.selectedRaven.liveMedia[1].timestamp;
                    }
                }
            }
        } else if (props.selectedRaven.vehicleState) { // if no live mqtt data, try to fall back on vehicle state
            if (props.selectedRaven.vehicleState.currentPreviewUrls) {
                if (props.selectedRaven.vehicleState.currentPreviewUrls.length > 0) {
                    if (props.selectedRaven.vehicleState.currentPreviewUrls[0]) {
                        liveMediaRoadCameraImage = props.selectedRaven.vehicleState.currentPreviewUrls[0].finalUrl;
                        liveMediaRoadCameraDate = RavenUtil.convertTs(props.selectedRaven.vehicleState.currentPreviewUrls[0].ts);
                    }
                    if (props.selectedRaven.vehicleState.currentPreviewUrls.length > 1) {
                        if (props.selectedRaven.vehicleState.currentPreviewUrls[1]) {
                            liveMediaCabinCameraImage = props.selectedRaven.vehicleState.currentPreviewUrls[1].finalUrl;
                            liveMediaCabinCameraDate = RavenUtil.convertTs(props.selectedRaven.vehicleState.currentPreviewUrls[1].ts);
                        }
                    }
                }
            }
        }

        return {
            liveMediaRoadCameraImage,
            liveMediaRoadCameraDate,
            liveMediaCabinCameraImage,
            liveMediaCabinCameraDate
        }
    }

    onLiveStream = (cameraType, streamStartDate = null) => {
        this.props.onLiveStream({
            ravenUuid: this.liveStreamRavenUuid(),
            vehicleName: this.props.selectedRaven.vehicle.name,
            defaultCamera: cameraType,
            startDate: streamStartDate
        });
    }

    liveStreamRavenUuid = () => {
        const isShowcase = this.props.features.showcase_raven_selector;
        if (isShowcase && this.props.showcaseTargetRavenUuid) {
            return this.props.showcaseTargetRavenUuid;
        }
        return this.props.selectedRaven.ravenUuid
    }

    render() {

        // console.log("VEHICLE DASHBOARD DETAILS PANEL", this.props, this.state);

        if (!this.props.selectedRaven) return null;

        if (this.props.selectedRaven.noServicePlan) {

            var linkurl = "/" + getCurrentLocale() + "/account/ravens?edit=" + this.props.selectedRaven.ravenUuid;

            return (
                <div className="details-panel">
                    <div className="row">
                        <div className="col-12 no-plan-message">
                            <h3>{strings.formatString(strings.no_plan_label)}</h3>
                            <Protected resource="ravens.service_plans" action="write" resourceId={this.props.selectedRaven.ravenUuid} >
                                <p>{strings.formatString(strings.no_plan_db_message, <span><br /><NavLink to={linkurl}>{strings.formatString(strings.click_here)}</NavLink></span>)}</p>
                                <Protected.Fallback>
                                    <p>{strings.no_plan_db_message_guest}</p>
                                </Protected.Fallback>
                            </Protected>
                        </div>
                    </div>
                </div>
            )
        }

        if (!this.props.selectedRaven.dashboard) return null;

        // Some code to safely adapt selectedRaven liveMedia|vehicleState props to liveMedia component props
        var liveMediaRoadCamera = {
            image : this.state.liveMediaRoadCameraImage,
            date : new Date(this.state.liveMediaRoadCameraDate)
        };
        var liveMediaCabinCamera = {
            image : this.state.liveMediaCabinCameraImage,
            date : new Date(this.state.liveMediaCabinCameraDate)
        }

        let mediaRequestType = EVENT_MEDIA_REQUEST_TYPE.NONE;
        if (this.props.features.media_request && this.props.selectedRaven.canRequestMedia && this.props.selectedRaven.apiProfile) {
            if (this.props.selectedRaven.apiProfile.userMediaRequest) {
                mediaRequestType = EVENT_MEDIA_REQUEST_TYPE.USER_MEDIA_REQUEST;
            } else if (this.props.selectedRaven.apiProfile.videoPreviewRequest) {
                mediaRequestType = EVENT_MEDIA_REQUEST_TYPE.VIDEO_PREVIEW_REQUEST;
            }
        }

        return (
            <div className="card-details-panel">
                <div className="col-12 info-panel" id={this.props.id}>
                    <VehicleInfo
                        id={RESOURCE_DETAILS_VEHICLE_INFO_UNIQUE_ID} // ref={this.vehicleInfoPrintRef} REACT REFS over-complicate accessing innerHTML
                        stage={this.props.stage} 
                        theme={this.props.theme}
                        raven={this.props.selectedRaven}
                        ravenUuid={this.props.selectedRaven.ravenUuid}
                        dashboardQueryCompleteTime={this.props.selectedRaven && this.props.selectedRaven.dashboard ? this.props.selectedRaven.dashboard.queryCompleteTime : null} // stopgap for RAV-2194 in lieu of more investigation (using queryCompleteTime to trigger purecomponent updates)
                        isDriving={this.props.selectedRaven.isDriving}
                        mqttService={this.props.mqttService}
                        features={this.props.features}
                        currentSpeed={this.props.currentSpeed}
                        unplugged={this.props.unplugged}
                        sdCardStatus={this.props.sdCardStatus}
                        unitOfMeasure={this.props.unitOfMeasure}
                    />
                    <VehicleTags raven={this.props.selectedRaven} {...this.props} />
                </div>

                <EventSection
                    id={RESOURCE_DETAILS_EVENT_SECTION_UNIQUE_ID} // ref={this.eventSectionPrintRef} REACT REFS over-complicate accessing innerHTML
                    card={this.props.selectedRaven.dashboard /* for segments, speedZones */}
                    selectedEvent={this.props.selectedEvent}
                    onSelectEvent={this.props.onSelectEvent}
                    events={this.props.selectedRaven.dashboard.events}
                    enhancedVideoAccessModeActive={this.props.enhancedVideoAccessModeActive}
                    toggleEnhancedVideoAccessModeActive={this.props.toggleEnhancedVideoAccessModeActive}
                    allSupportedEvents={this.props.selectedRaven.dashboard.allSupportedEvents} //TODO remove by moving to the redux store
                    mediaRequestType={mediaRequestType}
                    unitOfMeasure={this.props.unitOfMeasure}
                    print={printResourceDetailsForTrip}
                />

                { this.props.features.media_view && this.props.selectedRaven.canViewMedia ? 

                    <> { this.props.selectedEvent ?

                        <div className="multi-panel-wrapper">

                            {this.props.selectedEvent.clustered ? // should the panel be a clustered component or a regular event media component?
                                <EventClusterMediaCarousel
                                    events={this.props.selectedRaven.dashboard.events} // cardEvents as in all events, not just the cluster events
                                    onSelectEvent={this.props.onSelectEvent}
                                    selectedRavenUuid={this.props.selectedRaven.ravenUuid}
                                    selectedEvent={this.props.selectedEvent}
                                    mqttService={this.props.mqttService}
                                    features={this.props.features}
                                    mediaRequestType={mediaRequestType}
                                    onLiveStream={this.onLiveStream}
                                    unplugged={this.props.selectedRaven.unplugged}
                                    offline={(this.props.selectedRaven.vehicleState && this.props.selectedRaven.vehicleState.ravenOffline)}
                                />
                            :
                                <EventMedia
                                    selectedRavenUuid={this.props.selectedRaven.ravenUuid}
                                    selectedEventId={this.props.selectedEvent.eventId}
                                    mqttService={this.props.mqttService}
                                    features={this.props.features}
                                    mediaRequestType={mediaRequestType}
                                    unplugged= { this.props.selectedRaven.unplugged }
                                    offline= { (this.props.selectedRaven.vehicleState && this.props.selectedRaven.vehicleState.ravenOffline) }
                                    onLiveStream={this.onLiveStream}
                                />
                            }

                            {this.props.selectedEvent.type.endsWith("_STREAMING") === false ? // add another panel to the "multi-panel-wrapper" children?
                                <EventMedia
                                    shouldShowAlternateCameraType={true}
                                    selectedRavenUuid={this.props.selectedRaven.ravenUuid}
                                    selectedEventId={this.props.selectedEvent.eventId}
                                    mqttService={this.props.mqttService}
                                    features={this.props.features}
                                    mediaRequestType={mediaRequestType}
                                    unplugged= { this.props.selectedRaven.unplugged }
                                    offline= { (this.props.selectedRaven.vehicleState && this.props.selectedRaven.vehicleState.ravenOffline) }
                                    onLiveStream={this.onLiveStream}
                                />
                            :
                                null // streaming playback does not support two separate cameras (or it is a clustered component if multiple streaming events on the same timestamp)
                            }
                        </div>
                    :
                        <div className="multi-panel-wrapper">
                            <LiveMedia
                                roadCamera = {liveMediaRoadCamera}
                                cabinCamera = {liveMediaCabinCamera}
                                unplugged= { this.props.selectedRaven.unplugged }
                                offline= { (this.props.selectedRaven.vehicleState && this.props.selectedRaven.vehicleState.ravenOffline) }
                                onLiveStream={this.onLiveStream}
                            />
                            <LiveMedia
                                shouldShowAlternateCameraType={true}
                                roadCamera = {liveMediaRoadCamera}
                                cabinCamera = {liveMediaCabinCamera}
                                unplugged= { this.props.selectedRaven.unplugged }
                                offline= { (this.props.selectedRaven.vehicleState && this.props.selectedRaven.vehicleState.ravenOffline) }
                                onLiveStream={this.onLiveStream}
                            />
                        </div>

 
                    /* end media_view */ 
                    } </> : null
                }
            </div>
        )
    }
}

VehicleDetail.propTypes = {
    features: PropTypes.shape({
        debug: PropTypes.bool,
        media_request: PropTypes.bool,
    }).isRequired,
    stage: PropTypes.string.isRequired,
    theme: PropTypes.string.isRequired,
    selectedEvent: PropTypes.shape({
        media: PropTypes.arrayOf(PropTypes.shape({
            signedUrl: PropTypes.string
        }))
    }),
    selectedRaven: PropTypes.shape({
        ravenUuid: PropTypes.string.isRequired,
        noServicePlan: PropTypes.bool,
        dashboard: PropTypes.shape({
            events: PropTypes.arrayOf(PropTypes.object)
        })
    }).isRequired,
    mqttService: PropTypes.object,
    unitOfMeasure: PropTypes.string.isRequired,
    showcaseTargetRavenUuid: PropTypes.string,
}
